import { yupResolver } from '@hookform/resolvers/yup';
import { NewPaymentProvider } from 'components/payment/payment.context';
import SpreedlyCheckoutSdkForm from 'components/payment/spreedly-checkout-sdk/spreedly-card/forms/spreedly-checkout-sdk-form.component';
import { getSchema } from 'components/payment/spreedly/spreedly-card/spreedly-card.utils';
import { useMobileAppListeners } from 'hooks/mobileAppListeners/useMobileAppListeners';
import { FormProvider, useForm } from 'react-hook-form';

const SpredlyPaymentHostedForm = ({
  initOrderResponse,
  loading,
  refetchInitOrder,
}) => {
  const initOrderAttributes = initOrderResponse?.attributes;
  const formName = initOrderAttributes?.hostedPaymentPageName;

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(getSchema(formName)),
  });

  const fireListeners = useMobileAppListeners();

  const onSuccess = (_token, data) => {
    fireListeners(data);
  };

  // No-op: useSpreedlyCheckoutSdkForm already calls refetchInitOrder() itself
  // for genuine server rejections (see the `error` dispatch in
  // spreedly-checkout-sdk-form.hooks.js) — calling it again here would
  // double-refetch.
  const onError = () => {};

  return (
    <FormProvider {...methods}>
      <NewPaymentProvider
        value={{ initOrderResponse, refetchInitOrder, loading }}
      >
        <SpreedlyCheckoutSdkForm
          formName={formName}
          initOrderAttributes={initOrderAttributes}
          onSuccess={onSuccess}
          onError={onError}
          showSaveCardCheckbox={false}
          disabled={loading}
          button
        />
      </NewPaymentProvider>
    </FormProvider>
  );
};

export default SpredlyPaymentHostedForm;
